import { render } from "./BinaryChoice.vue?vue&type=template&id=630acbea&scoped=true&ts=true"
import script from "./BinaryChoice.vue?vue&type=script&lang=ts"
export * from "./BinaryChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./BinaryChoice.vue?vue&type=style&index=0&id=630acbea&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-630acbea"]])

export default __exports__